import { ArtButton } from "components/button";
import { PasswordInput } from "components/input/password-input";
import { CustomerInterface } from "interfaces";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { RootState } from "reducer/store";
import { setAuthInfos } from "reducer/wallet.slice";
import { api, ui, utils } from "services";
import crypt from "services/crypt";

export default function LinkEmailPage() {
  const { t } = useTranslation();
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isValidToken, setIsValidToken] = useState(null);
  const [identity, setIdentity] = useState("");
  const [err, setErr] = useState("");
  const nav = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector((state: RootState) => state.user);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    crypt.verifyJwt(token).then(data => {
      setIdentity(data.email);
      setIsValidToken(true);
    }).catch(err => {
      ui.alert('Your token is invalid !')
    })
  }, [])

  const onSubmit = async (e: any) => {
    try {
      e.preventDefault();
      setLoading(true);
      const authInfo = await api.linkEmail(token, password)
      if (userInfo?.[CustomerInterface.id]) {
        dispatch(setAuthInfos(authInfo))
      }
      await api.loginByPassword(identity, password);
      setLoading(false);
      nav("/")
      ui.alertSuccess("Linking email", "Link email successful !")
    } catch (err: any) {
      setLoading(false);
      ui.alertFailed("Link email failed !", t(err.message));
    }
  }

  return (
    <div className="w-full dao-container">
      {isValidToken &&
        <div className="w-full w-full modal fixed w-full h-full top-0 left-0 flex items-center justify-center">
          <form className="shadow-md border border-black rounded px-8 py-8 pb-12 mb-4 w-[564px] bg-black-secondary">
            <div className="text-2xl text-white font-semibold text-center mb-6">
              Connect Email Account
            </div>
            <img src="/assets/images/hr.svg" alt="hr" className="w-full object-cover h-1 mb-9" />
            <PasswordInput setPassword={setPassword} fieldName={"Password"} password={password} className="mb-2" setErr={setErr} />
            <PasswordInput setPassword={setConfirmPassword} fieldName={"Confirm password"} password={confirmPassword} setErr={setErr} validation={
              (data: any) => {
                if (data !== password) {
                  return "Confirm password not match with password"
                }
                return "";
              }
            } />
            <div className="w-[140px] mt-6 mx-auto">
              <ArtButton
                className="text-white font-bold w-full py-2 rounded"
                color="yellow"
                disabled={!!err || !password || !confirmPassword || loading}
                loading={loading}
                onClick={onSubmit}
              >{t("submit")}</ArtButton>
            </div>
          </form>
        </div >
      }
      {isValidToken === false &&
        <div className="w-full max-w-md m-auto mt-10 text-lg text-center">
        </div>
      }
    </div >
  )
}
